module.exports = __webpack_public_path__ + "static/media/Headshot.ece5ddff.png";